import { z } from "zod/v4";

export const reminderConfigResponseSchema = z.object({
	id: z.string(),
	club_id: z.string(),
	// Escalation policy: first reminder N days BEFORE due, warning/final N days AFTER.
	reminder_days_offset: z.number().int().min(0),
	warning_days_offset: z.number().int().min(0),
	final_days_offset: z.number().int().min(0),
	created_at: z.coerce.date(),
	updated_at: z.coerce.date(),
});

export const updateReminderConfigSchema = z.object({
	reminder_days_offset: z.number().int().min(0),
	warning_days_offset: z.number().int().min(0),
	final_days_offset: z.number().int().min(0),
});

export type ReminderConfigResponse = z.infer<typeof reminderConfigResponseSchema>;
export type UpdateReminderConfig = z.infer<typeof updateReminderConfigSchema>;
